// extracted by mini-css-extract-plugin
export var csatScore = "_lj-5";
export var header = "_lj-1";
export var panelWrapper = "_lj-2";
export var postPreview = "_lj-3";
export var rightContent = "_lj-0";
export var wrappingText = "_lj-4";